<template>
  <LabelledInput
    :label="label ? `${label} Button`: 'Button'"
    helpful-tip="Customise the label and icon for each button"
  >
    <b-input-group
      prepend="Label"
      class="mb-1"
    >
      <b-input
        v-model="buttonName"
        type="text"
        :placeholder="placeholder"
      />
    </b-input-group>
    <ImageUpload :config-path="iconConfigPath" />
  </LabelledInput>
</template>

<script lang="ts">

import Vue, { PropType } from 'vue'
import Component from 'vue-class-component'

import ImageUpload from '@/components/builder/images/ImageUpload.vue'
import LabelledInput from '@/components/builder/UI/LabelledInput.vue'

const components = {
  ImageUpload,
  LabelledInput,
}

const props = {
  label: {
    type: String,
    default: '',
  },
  placeholder: {
    type: String,
    default: '',
  },
  nameConfigPath: {
    type: Array as PropType<string[]>,
    required: true,
  },
  iconConfigPath: {
    type: Array as PropType<string[]>,
    required: true,
  },
}

@Component({ components })
export default class NavButtonSettings extends Vue.extend({ props }) {
  get buttonName () {
    return this.$typedStore.primary.app.nestedConfig(this.nameConfigPath)
  }

  set buttonName (newValue) {
    this.$typedStore.primary.app.updateConfig({
      configPath: this.nameConfigPath,
      value: newValue,
    })
  }
}

</script>
